import { createGlobalStyle } from 'styled-components'

export const EstiloGlobal = createGlobalStyle` 
  * {    
    font-family: Rubik;
  }
`
